import styled from 'styled-components';

export const ContainerPrint = styled.div`
  display: flex;
  gap: 8px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  margin-bottom: 16px;

  @media print {
    display: none !important;
  }
`;
